import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Breadcrumb } from '@app/models/_base/breadcrumb.model';
import { KeyValuePair } from '@app/models/_shared/keyValue';
import { CourseFilter } from '@app/models/courses/filter.model';
import {
  PrimaryCourseFilterRequest,
  PrimaryCourseFiltersRequest
} from '@app/models/courses/filterRequest.primary.model';
import { CourseService } from '@app/services/course.service';
import { CentigradeService } from '@app/services/centigrade.service';
import { Footer } from '@app/services/footer.service';
import { LocalisationService } from '@app/services/localisation.service';
import { QuestionnaireService } from '@app/services/questionnaire.service';
import { RouteBreadcrumbs } from '@app/services/routeBreadcrumbs.service';
import * as _ from 'lodash';

import { CourseAreaApplyFiltersComponent } from './../../../../components/course-areas/filters/course-area-apply-filters/course-area-apply-filters.component';

@Component({
  selector: 'app-course-area-points-filter',
  templateUrl: './course-area-points-filter.component.html',
  styleUrls: ['./course-area-points-filter.component.scss'],
  providers: [CentigradeService]
})
export class CourseAreaPointsFilterComponent implements OnInit {
  public static route: string = CourseAreaApplyFiltersComponent.route + '/grades-filter';
  public static footerPath: string = CourseAreaApplyFiltersComponent.route;

  locale: any = {};

  gradeCourseFilter: CourseFilter;
  gradeIndex: number = 0;
  forecastGradeIndex: number = null;

  grade: KeyValuePair<string, string>;
  forecastGrade: KeyValuePair<string, string>;
  otherGrades: KeyValuePair<string, string>[];

  changedInfo: boolean = false;

  constructor(
    private routeBreadcrumbs: RouteBreadcrumbs,
    private footerService: Footer,
    private courseService: CourseService,
    private questionnaireService: QuestionnaireService,
    private router: Router,
    private localisation: LocalisationService,
    private centigradeService: CentigradeService
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('CourseAreaPointsFilterComponent');

    let parentLocale = this.localisation.getTranslationsForComponent(
      'CourseAreaApplyFiltersComponent'
    ) as any;

    this.routeBreadcrumbs.breadcrumbs.next([
      new Breadcrumb(parentLocale.breadcrumbText, CourseAreaApplyFiltersComponent.route),
      new Breadcrumb(this.locale.breadcrumbText, null)
    ]);

    this.footerService.update({
      title: this.locale.footerText,
      action: () => this.submitGrade(this)
    });

    this.centigradeService.getUserAcademicLevel().subscribe(response => {
      if (response.gradeIndex != null) {
        this.forecastGradeIndex = response.gradeIndex;
        this.gradeIndex = this.forecastGradeIndex;
      }
      this.getPrimaryCourseFilters(null);
    });
  }

  submitGrade(scope: this): void {
    if (this.changedInfo == true) {
      /*
      * Now Reset any settings prior
      */
      this.courseService.updateCategorySelected(2); // reset the category return to default
      this.courseService.deleteSecondaryFilters().subscribe(filters => {}); // reset secondary filters
      this.changedInfo = false;
    }

    scope.gradeCourseFilter.completed = true;
    _.forEach(scope.gradeCourseFilter.options, (opt, key) => {
      if (key == scope.gradeIndex) {
        opt.selected = true;
      } else {
        opt.selected = false;
      }
    });

    scope.courseService
      .savePrimaryCourseFilter(new PrimaryCourseFilterRequest(scope.gradeCourseFilter))
      .subscribe(filters => {
        scope.router.navigate(['/centigrade/course-area-filters']);
      });
  }

  reset() {
    this.courseService.deletePrimaryCourseFilter(this.gradeCourseFilter.id).subscribe(filters => {
      this.router.navigate(['/centigrade/course-area-filters']);
    });
  }

  bindGradeInformation(values: KeyValuePair<string, string>[]): void {
    this.grade = values[0];
    this.otherGrades = values.filter(e => e.key != this.grade.key);
  }

  bindForecastGradeInformation(values: KeyValuePair<string, string>[]): void {
    this.forecastGrade = values[0];
  }

  getGradeString(grade: KeyValuePair<string, string>): string {
    let test = grade;
    switch (grade.key) {
      case 'a_level':
        return this.locale.aLevelLabelText;
      case 'ib_points':
        return this.locale.ibLabelText;
      case 'ucas_points':
        return this.locale.ucasLabelText;
      case 'scottish_higher':
        return this.locale.scottishHighersLabelText;
      case 'leaving_point':
        return this.locale.leavingLabelText;
      case 'french_bacc':
        return this.locale.frenchBaccLabelText;
      case 'french_oib':
        return this.locale.oibLabelText;
    }
  }

  increaseGrades(): void {
    this.changedInfo = true;

    if (this.gradeCourseFilter != undefined) {
      this.gradeIndex + 1 > this.gradeCourseFilter.options.length - 1
        ? (this.gradeIndex = 0)
        : this.gradeIndex++;
      this.bindGradeInformation(this.gradeCourseFilter.options[this.gradeIndex].values);
    }
  }

  decreaseGrades(): void {
    this.changedInfo = true;

    if (this.gradeCourseFilter != undefined) {
      this.gradeIndex - 1 < 0
        ? (this.gradeIndex = this.gradeCourseFilter.options.length - 1)
        : this.gradeIndex--;
      this.bindGradeInformation(this.gradeCourseFilter.options[this.gradeIndex].values);
    }
  }

  getPrimaryCourseFilters(filters: PrimaryCourseFiltersRequest) {
    this.courseService.getPrimaryCourseFilters(filters).subscribe(filters => {
      //Populate join course filter toggle area.
      let filterId = filters.filters.find(filter => filter.tag == 'FTYPE_TARIFF').id;

      this.courseService.getPrimaryCourseFilterDetails(filterId).subscribe(filter => {
        this.gradeCourseFilter = filter.filter;

        if (this.forecastGradeIndex) {
          this.bindForecastGradeInformation(
            this.gradeCourseFilter.options[this.forecastGradeIndex].values
          );
        }

        if (this.gradeCourseFilter.isRequired) {
          this.questionnaireService.statusOverride.next(300);
        } else {
          this.questionnaireService.statusOverride.next(null);
        }

        // if previously filled in
        if (this.gradeCourseFilter.completed) {
          this.gradeIndex = this.gradeCourseFilter.options.findIndex(opt => opt.selected);
        }

        this.bindGradeInformation(this.gradeCourseFilter.options[this.gradeIndex].values);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/course-areas/filters/course-area-points-filter/course-area-points-filter.component.ts